import React from 'react';
import { StyledUrgentHelpContentContainer, StyledChapterTitle, StyledChapterButton, StyledUrgentHelpContent } from './PlayerDashboard.styled';
import { IDashboardBlock } from 'models/IContentBase';
import { StyledChapterEntryIcon } from './PlayerDashboardEntry.styled';
import { useNavigate } from 'react-router-dom';

interface IUrgentHelpBlockProps {
  content: IDashboardBlock;
}

export const UrgentHelpBlock: React.FC<IUrgentHelpBlockProps> = ({ content }) => {
  const navigate = useNavigate();

  const onClickHandler = () => {
    //open a new tab to the destination page
    navigate(content.to);
  }

  return (
    <StyledUrgentHelpContentContainer onClick={onClickHandler}>
      <StyledChapterEntryIcon cmsSrc={content.imgUrl} />
      <StyledUrgentHelpContent>
        <StyledChapterTitle dangerouslySetInnerHTML={{ __html: content.title }} />
        <StyledChapterTitle dangerouslySetInnerHTML={{ __html: content.description }} />
        <StyledChapterButton cmsSrc={'images/button'} />
      </StyledUrgentHelpContent>
    </StyledUrgentHelpContentContainer> 
  )
}